var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex flex-center w-24 h-24" }, [
      _c("img", {
        staticStyle: { filter: "brightness(213%)" },
        attrs: {
          src: require("@/assets/icons/assist-icon.svg"),
          width: "18",
          height: "18",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }